import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';

import { DealerResetPasswordComponent } from './dealer-reset-password/dealer-reset-password.component';

import { AuthenticationService } from '@app/shared/services/authentication.service';
import { UserAuthority } from '@app/domain/model/user-authority';
import { validateDealerId } from '@app/shared/validators/dealer-id.validator';
import { FormControlUtils } from '@app/util/form-group-utils';

@Component({
  templateUrl: './dealer-login-form.component.html',
  styleUrls: ['./dealer-login-form.component.scss']
})
export class DealerLoginFormComponent implements OnInit {

  loginForm: FormGroup;

  message: string;

  private returnUrl: string;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly authenticator: AuthenticationService,
    private readonly modalService: NgbModal
  ) {
    this.getReturnUrl();
    this.checkIfUserIsLoggedIn();
  }

  ngOnInit() {
    this.initForm();
  }

  hasError(controlName: string, validation?: string) {
    const control = this.loginForm.controls[controlName];
    if (validation) {
      return control.errors[validation];
    } else {
      return control.errors && control.touched;
    }
  }

  onSubmit() {
    FormControlUtils.markAllTouched(this.loginForm);

    if (this.loginForm.invalid) {
      return;
    }

    this.message = null;

    this.authenticator.login(this.loginForm.value)
      .pipe(first())
      .subscribe(
        data => {
          if (data) {
            this.router.navigate([this.returnUrl]);
          } else {
            this.message = 'Invalid license number and/or password. Please try again.';
          }
        },
        error => {
          this.message = 'Unable to perform the authentication. Please, contact customer support.';
        });
  }

  resetPassword() {
    this.modalService.open(DealerResetPasswordComponent, { backdrop: 'static', keyboard: false });
  }

  private initForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, validateDealerId]],
      password: ['', Validators.required]
    });
  }

  private getReturnUrl() {
    const returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'];

    if (returnUrl && returnUrl !== '/login') {
      this.returnUrl = returnUrl;

      return;
    }

    this.returnUrl = '/';
  }

  private checkIfUserIsLoggedIn() {
    if (!this.authenticator.isLoggedIn()) {
      return;
    }

    if (this.authenticator.getCurrentUser().hasAuthority(UserAuthority.DEALER_INFO)) {
      this.router.navigate(['/admin']);
      return;
    }

    this.router.navigate([this.returnUrl]);
  }

}
